export default __webpack_public_path__ + "static/media/goldfavicon.8f691a15.ico";